import React from "react"
import { Tag } from "@chakra-ui/react"
import { useAtom } from "jotai"
import { userDetailsAtom } from "../Menu/menu.store"

export const isTruthy = (value: string | null | object | undefined | number): boolean => {
  return Boolean(value)
}
export const scrollTo = (posX: number, posY: number): void => {
  window.scrollTo(posX, posY)
}

export const ErrorTag = ({ message }: { message: string }): JSX.Element => (
  <Tag bg="yellow" color="red" display={"block"} p="2" w="100%" mt="4">
    {message}
  </Tag>
)

export const getLandscapeOrPortraitValues = (landscapeValue: string, portraitValue: string, isLandscape: boolean): string => {
  return isLandscape ? landscapeValue : portraitValue
}

export const useIsLoggedIn = (): boolean => {
  const [userDetails] = useAtom(userDetailsAtom)
  return Boolean(userDetails)
}
